import { RumGlobal } from '@datadog/browser-rum';
import React, { PropsWithChildren, useMemo } from 'react';
import packageJSON from '../../../package.json';
import { datadog } from './datadog';

type Props = PropsWithChildren<{
  datadogInstance?: RumGlobal;
}>;

export const DatadogProvider: React.FC<Props> = ({
  children,
  datadogInstance = datadog,
}) => {
  useMemo(() => {
    datadogInstance.init({
      applicationId: '5542e7ec-e7d4-4e21-a207-9404bd06224b',
      clientToken: 'pub48418ebebd9b6089f3da000428298aa7',
      site: 'datadoghq.com',
      service: 'platane',
      env: process.env.NODE_ENV,
      version: packageJSON.version,
      replaySampleRate: 0, // deactivate replay-session
      sampleRate: 100,
      trackInteractions: true,
    });
  }, [datadogInstance]);

  return <>{children}</>;
};
